<template lang="pug">
//- 點數使用紀錄
.record-course-tab-four-view
  //- 篩選器
  FilterCom(
    :language_filter="language_filter",
    :class_filter="class_filter",
    @setLang="setCourseLange",
    @setCourse="setCourseType",
    use_type="history"
  )
  .record-course-title 課程紀錄
  .record-timetable-main
    //- 今天
    TimeableItem(
      :language_filter="language_filter",
      :class_filter="class_filter",
      :date_filter="$root.common.getNowTime('date')",
      use_type="history-today"
    )

    //- 昨天
    TimeableItem(
      :language_filter="language_filter",
      :class_filter="class_filter",
      :date_filter="$root.common.getNowTime('date')",
      use_type="history-yesterday"
    )

    //- 要給他列表
    //- :course_list="",
</template>

<script>
import FilterCom from '@/components/filter'
import TimeableItem from '@/components/history/history-timetable-item'
export default {
  data () {
    return {
      //- 語言篩選狀態
      language_filter: "all",
      //- 課程篩選狀態
      class_filter: "all",
    }
  },
  components: {
    FilterCom,
    TimeableItem
  },
  created () {
  },
  methods: {
    // 設定課程語言
    setCourseLange (_langID) {
      this.language_filter = _langID
    },
    // 設定課程類別
    setCourseType (_courseType) {
      this.class_filter = _courseType
    },
  }
}
</script>
<style lang="sass" scoped>
</style>
